import utils from './utils';
import "@lottiefiles/lottie-player";
import style from './components/style';
import menu from './components/menu';
import slider from './components/slider';
import accordion from './components/accordion';
import map from './components/map';
import animations from './components/animations';

function initHiPriorityCommon() {
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
	style.init();
	slider.init();
    menu.init();
    accordion.init();
    map.init();
	animations.initBaseAnimations();
} 

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
 